import axios from "axios";
import { api } from "../constants/Constant";

export const httpClient = axios.create({
  baseURL: api,
  headers: {
    "Content-Type": "application/json",
  },
});

